const NO_CONSENT_ID = '0'

export const getMarketingConsentId = (): string | undefined => {
  const cookiebot = window.Cookiebot
  const consentId = cookiebot?.consentID

  return cookiebot?.consent?.marketing && consentId && consentId !== NO_CONSENT_ID ? consentId : undefined
}
